<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->

<div class="col p-0">
    <app-back-button *ngIf="showBackButton" class="mb-3 d-block"></app-back-button>
    <img
        class="project-logo mb-3"
        src="https://s3.amazonaws.com/lfx-project-logos/400x245.png"
        alt="{{ project?.name }}"
    >
    <h2 class="display-4">{{ project?.name }}</h2>
    <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/project-column/project-column.component.html